import { Component, Input, OnInit } from '@angular/core';
import { ErrorConstants } from '../../models/errorConstants';
import { EmployeeService } from 'src/app/core/http/employee/employee.service';
import { GlobalService } from 'src/app/core/services/global.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { EventService } from 'src/app/core/services/event.service';
import { ToastrService } from 'ngx-toastr';
import { CurrencyFormatService } from 'src/app/core/services/currency-format.service';

@Component({
    selector: 'app-paynow',
    templateUrl: './paynow.component.html',
    styleUrls: ['./paynow.component.css']
})
export class PaynowComponent implements OnInit {

    @Input() invoiceId: any = '';
    InvoicesList: any[];
    validationMessage = ErrorConstants;
    public isEmployee: boolean = true;
    public invoicePaymentDetails: any = {
        invoiceId: "",
        paymentMethodId: "",
        invoiceNumber: "",
        premiumAmount: "",
        bankFee: "",
        totalPayment: "",
        paymentMethod: "",
        payType: "",
        lastFourDigits: ""
    };
    failedPayment: boolean = false;
    failedPaymentError: string = "";
    paymentWarningMessage = '';


    constructor(private employeeService: EmployeeService,
        public global: GlobalService,
        public navigation: NavigationService,
        private eventService: EventService,
        private toastr: ToastrService,
        public currencyService: CurrencyFormatService) {
    }

    ngOnInit(): void {
        this.eventService.on('employeeInvoicePayment', (data) => {
            this.invoicePayment(data);
        });

        this.isEmployee = !(this.global.getRole() == 'Employee' && this.global.isAdmin())
    }

    /**
     * This function is used to get payment details and open paynow modal.
     * @param {object} invoiceData invoice details.
     */
    invoicePayment(invoiceData) {
        const invoiceId = this.isEmployee ? invoiceData.invoiceId : invoiceData.groupbillid;
        this.employeeService.getEmployeePaymentDetails(invoiceId).subscribe((response: any) => {
            if (response.status) {
                const paymentData = response.data;
                this.setPaymentDetails(paymentData, invoiceData);
                (<any>$('#invoicePayment')).modal('show');
            } else {
                if (response.data?.oldInvoices) {
                    this.paymentWarningMessage = response.message;
                    (<any>$('#paymentWarningModal')).modal('show');
                } else {
                    this.toastr.warning(response.message);
                }
            }
        });
    }

    closeWarningModal() {
        (<any>$('#paymentWarningModal')).modal('hide');
    }

    /**
     * This function is used to invoice payment and close paynow modal.
     */
    processInvoicePayment() {
        this.employeeService.employeeInvoicePayment(this.invoicePaymentDetails).subscribe((response: any) => {
            if (response.status) {
                (document.activeElement as HTMLElement)?.blur();
                (<any>$('#invoicePayment')).modal('hide');
                this.toastr.success(response.message);
                this.global.getRefreshData();
            } else {
                this.failedPayment = true;
                this.failedPaymentError = response.data.error;
                (document.activeElement as HTMLElement)?.blur();
                (<any>$('#invoicePayment')).modal('hide');
                (<any>$('#failedPayment')).modal('show');
            }
        });
    }

    /**
     * This function is used to set payment details.
     * @param {object} paymentData Payment details.
     * @param {object} invoiceData Invoice details.
     */
    setPaymentDetails(paymentData, invoiceData) {
        this.invoicePaymentDetails.invoiceId = invoiceData.invoiceId;
        this.invoicePaymentDetails.paymentMethodId = paymentData.id;
        this.invoicePaymentDetails.invoiceNumber = invoiceData.invoiceNo;
        this.invoicePaymentDetails.bankFee = invoiceData.feeAmount;
        this.invoicePaymentDetails.premiumAmount = invoiceData.balance - this.invoicePaymentDetails.bankFee - invoiceData.miscFee;
        this.invoicePaymentDetails.totalPayment = invoiceData.balance;
        this.invoicePaymentDetails.paymentMethod = paymentData.paymentType == 'CC' ? paymentData.card : paymentData.accountNumber;
        this.invoicePaymentDetails.payType = paymentData.paymentType;
        this.invoicePaymentDetails.miscFee = invoiceData.miscFee;
        this.invoicePaymentDetails.groupbillNo = invoiceData.groupbillNo;
        this.invoicePaymentDetails.identifier = paymentData.identifier;
        this.invoicePaymentDetails.lastFourDigits = paymentData?.lastFourDigits ? paymentData?.lastFourDigits : '';

        /* IES-1900 : Pay Now button to invoices in ER portal */
        if (!this.isEmployee) {
            const premiumAmount: any = invoiceData.balance - invoiceData.bankFee;
            this.invoicePaymentDetails.totalPayment = invoiceData.balance;
            this.invoicePaymentDetails.bankFee = parseFloat(invoiceData.bankFee);
            this.invoicePaymentDetails.premiumAmount = parseFloat(premiumAmount);
        }
    }

    /**
     * This function is used to Calculate bankFee.
     * @param {object} paymentData Payment details.
     * @param {object} invoiceData Invoice details.
     * @returns {number} Returns bankFee.
     */
    calculateBankFee(paymentData, invoiceData) {
        let bankFee: any = 0.00;

        switch (paymentData.paymentType) {
            case 'CC':
                bankFee = parseFloat(invoiceData.ccFee).toFixed(2);
                break;
            case 'ACH':
                bankFee = parseFloat(invoiceData.achFee).toFixed(2);
                break;
        }

        return bankFee;
    }

    /**
     * This function is used to close paynow modal.
     */
    closeModal() {
        if (this.failedPayment) {
            this.failedPayment = false;
            this.failedPaymentError = "";
            (<any>$('#failedPayment')).modal('hide');
            this.global.getRefreshData();

        } else {
            (<any>$('#invoicePayment')).modal('hide');
        }

    }

}
